import { render, staticRenderFns } from "./index.vue?vue&type=template&id=49df9162&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=49df9162&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49df9162",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49df9162')) {
      api.createRecord('49df9162', component.options)
    } else {
      api.reload('49df9162', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=49df9162&scoped=true", function () {
      api.rerender('49df9162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/priceSetting/component/goodPrice/index.vue"
export default component.exports